import React from 'react';
import { Col, Row, Button, Modal } from "react-bootstrap";
import { HelpOutline } from "@material-ui/icons";
import { connect } from 'react-redux';
import { getNotificatioListAction, readNotificationsAction, clearNotificationsAction } from '../../actions/NotificationActions';
import NotificationList from "./NotificationList";

class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userNotifications : undefined,
      unreadCnt:0,
      showLoader:true,
      isShowPrompt: false,
      totalCount:0,
      offset:0,
      hasMoreItems: true
    };

    this.getNotifications = this.getNotifications.bind(this);
  }

   /**
   * @desc Get list of notification based on user
   */
  getNotifications() {
    let offset = this.state.offset;
    let userNotifications = !!this.state.userNotifications ? this.state.userNotifications : []
    this.props.getNotificatioListAction(offset).then(res => {
    
        if(this.props.userNotifications.data && this.props.userNotifications.data.length > 0) {
          let newNotifications = !!this.props.userNotifications.data ? this.props.userNotifications.data : [];
          let all = userNotifications.concat(newNotifications);
          this.setState({
            userNotifications: all,
            showLoader: false,
            totalCount : this.props.userNotifications.count || 0,
            offset: offset + 1,
            hasMoreItems : true
          });
        }
        else {
          this.setState({
            userNotifications: this.props.userNotifications.count > 0 ? userNotifications : [],
            totalCount : this.props.userNotifications.count || 0,          
            showLoader: false,           
            hasMoreItems : false
          })
        }     
        
    }).catch(err => {
      this.setState({
        userNotifications: userNotifications || [],
        showLoader: false,
      })
    });
  }
  
  clearNotifications() {
    this.setState({showLoader : true, isShowPrompt : false})
    this.props.clearNotificationsAction().then(res => {     
      if(!!this.props.clearNotiRes && this.props.clearNotiRes.success){
        this.setState({showLoader : false, offset:0});
        this.getNotifications();        
      }
    }).catch(err => {
      this.setState({showLoader : false, offset:0});
    })
  }

  componentDidMount() {
    this.props.readNotificationsAction([]).then(res =>{
     this.getNotifications();
    }).catch(err => {
      this.getNotifications();
    });
  }

  render() {
    if(this.state.showLoader ) {
      return(
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) 
    }
    else {
      if(this.state.totalCount == 0 && this.state.userNotifications !== undefined && this.state.userNotifications.length === 0) {
        return (
          <>
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
              <Col className="col-auto">
                <h4 className="title-med mt-0 pt-1">Notifications</h4>
              </Col>
            </Row>
            <div className="notification-wrapper">  
                <div className={"notification-single "}>
                  <Row>
                    <Col className="col-auto">
                     No new notifications
                    </Col>
                </Row>
              </div>
            </div>
            </>
        )
      }
      else {
        return (
          <>
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
              <Col className="col-auto">
                <h4 className="title-med mt-0 pt-1">Notifications</h4>
              </Col>
              <Col>
              <Button variant="outlined" color="secondary" onClick={() => this.setState({isShowPrompt : true})}>
                Clear All ({this.state.totalCount})
              </Button>
              </Col>
            </Row>
            <div className="notification-wrapper">   
              <NotificationList key={'notifications'}
                notificationlist={this.state.userNotifications} 
                fromHeader={false} 
                totalCount={this.state.totalCount}
                getNotifications={this.getNotifications}
                hasMoreItems={this.state.totalCount > 0 ? this.state.hasMoreItems : false}
                history={this.props.history}
               />
            </div>

            <Modal
                show={this.state.isShowPrompt}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
                className="modal-med modal-400 modal-delete"
                centered
                backdrop={false}
                onHide={() => {
                  this.setState({isShowPrompt : false});
                }}
              >
                <Modal.Body className="pb-0 text-center">
                  <HelpOutline />
                  <p>Are you sure you want to clear all notifications?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="btn-blue btn-outlined w-140"
                        onClick={() => {
                          this.setState({isShowPrompt : false});
                        }}
                    >
                      Cancel
                    </Button>
                    <Button
                        variant="primary"
                        className="btn-blue w-140"
                        onClick={() => {
                          this.clearNotifications();
                        }}
                    >
                      Yes
                    </Button>
                </Modal.Footer>
              </Modal>
              
          </>
        );
      }  
    }
  }
}

const mapStateToProps = state => {
  return {
    userNotifications: state.reducer.userNotifications,
    clearNotiRes: state.reducer.clearNotiRes,
    readNotiRes : state.reducer.readNotiRes
  };
};

export default connect(mapStateToProps, { getNotificatioListAction, clearNotificationsAction, readNotificationsAction })(Notification)
